import React from 'react';
import TreeMenu from '../../common/TreeMenu';
import usePermission from '../../../hooks/usePermission';

function ManageUser() {
  const dataTree = [
    {
      id: 'USER_MANAGEMENT',
      title: 'Quản lý người dùng',
      url: '/user-management/user',
    },
  ];

  usePermission(['ROLE_ADMIN']);

  return <TreeMenu dataTree={dataTree} />;
}

export default ManageUser;
